export const CONTENTFUL_ACCESS_TOKEN = process.env.CONTENTFUL_ACCESS_TOKEN ?? '';
export const CONTENTFUL_SPACE_ID = process.env.CONTENTFUL_SPACE_ID ?? '';
export const GTM_ID = process.env.GTM_ID ?? '';
export const URL_LANDINGPAGE = process.env.URL_LANDING ?? '';
export const URL_RETOOL = process.env.API_URL_RETOOL??"https://tumomento.retool.com";